import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { NgxUploadFile, NgxUploadService } from '@sinapsys/ngx-upload';
import { Observable } from 'rxjs';
import { COMMON_APP_CONFIG } from '../tokens/common-config.token';
import { NgxCrudService } from '@sinapsys/ngx-crud';
import { FileSys } from '@models/fileSystem.model';

export interface UploadFileQueue {
  filename: string;
  data: FormData;
  progress: number;
  attempts: number;
  options: unknown;
}

/** Una foto caricata per una fotogallery. */
export interface ImmagineCaricata {
  disk_name: string;
  file_name: string;
  file_size: number;
  content_type: string;
  href: string;
}

export interface UploadedPdf {
  content_type: string;
  disk_name: string;
  file_name: string;
  file_path: string;
  file_size: number;
  href: string;
}

@Injectable({
  providedIn: 'root',
})
export class UploadsService extends NgxCrudService<FileSys, number> {

  constructor(@Inject(COMMON_APP_CONFIG) private mainConfig: Required<{ api: { apiBaseUrl: string } }>) {
    super({ apiBaseUrl: '' });
    this._baseUrl = this.mainConfig.api.apiBaseUrl + 'media/';
  }

  uploadFile(file: FileSys): Observable<FileSys> {
    return this.http.post<FileSys>(this._baseUrl + 'upload', file);
  }

  /**
   * Foto di una fotogallery, piu' file in una richiesta.
   *
   * Non passa da `uploadFile`: quella rotta cerca e sostituisce la riga con
   * `field: "imgUp"`, cioe' la copertina dell'articolo, e caricare una foto di
   * gallery cancellerebbe l'immagine di apertura.
   *
   * Gli indirizzi tornano nello stesso ordine in cui i file sono partiti.
   */
  caricaImmagini(files: File[]): Observable<{ immagini: ImmagineCaricata[] }> {
    const dati = new FormData();
    for (const file of files) dati.append('file', file);
    return this.http.post<{ immagini: ImmagineCaricata[] }>(this._baseUrl + 'upload-immagini', dati);
  }

  uploadPdf(file: File, articleId?: number): Observable<UploadedPdf> {
    const data = new FormData();
    data.append('file', file);
    if (articleId) data.append('articleId', String(articleId));
    return this.http.post<UploadedPdf>(this._baseUrl + 'upload-pdf', data);
  }
}
